import { withInstall } from '@lit-element/utils'

import Space from './src/space'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtSpace: SFCWithInstall<typeof Space> = withInstall(Space)
export default LtSpace

export * from './src/space'
export * from './src/item'
export * from './src/use-space'
